import { connect } from 'react-redux'

import { EditChefPayoutsModal } from '@components/order/edit'

import coordinators from '@coordinators'
import services from '@services'
import presenters from '@presenters'

import { HandleError } from '@coordinators/composed'

const mapStateToProps = (state) => {
  const { show } = state.editChefPayoutsModal
  const { order, orderStatus } = state
  const { payableChefPayoutSummaries = [] } = order

  return {
    payableChefPayoutSummaries,
    orderId: order.id,
    orderStatus,
    show,
    chefs: order.chefs || [],
  }
}

const mapDispatchToProps = () => {
  const { RestService, OrderService, UIService, ChefService } = services
  const { closeChefPayouts } = UIService.EditOrder

  const { AdjustChefPayoutsWithCategory, ChangeOrderStatus, LoadChefs } =
    coordinators
  const { pResponseOrder, pResponseChefs } = presenters.Api

  const adjustChefPayoutsWithCategory = AdjustChefPayoutsWithCategory({
    OrderService,
    RestService,
    UIService,
    pResponseOrder,
    HandleError,
  })
  const changeOrderStatus = ChangeOrderStatus({
    OrderService,
    RestService,
    pResponseOrder,
    UIService,
    HandleError,
  })
  const loadChefs = LoadChefs({ ChefService, RestService, pResponseChefs })

  const displayWarningMessage = (message) =>
    UIService.FlashMessage.displayWarningMessage(message)

  return {
    adjustChefPayoutsWithCategory,
    changeOrderStatus,
    closeChefPayouts,
    displayWarningMessage,
    loadChefs,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditChefPayoutsModal)
